import React, { useState, ChangeEvent } from 'react';
import './index.css';

interface OrdenarAnunciosHomeProps {
    onOrdenarChange: (opcao: string) => void;
}

const OrdenarAnunciosHome: React.FC<OrdenarAnunciosHomeProps> = ({ onOrdenarChange }) => {
    const [opcaoSelecionada, setOpcaoSelecionada] = useState<string>('');

    const trocarOpcao = (event: ChangeEvent<HTMLSelectElement>) => {
        const novaOpcao = event.target.value;
        setOpcaoSelecionada(novaOpcao);
        onOrdenarChange(novaOpcao);
    }

    return (
        <div className='selectOrdenarAnunciosHome'>
            <label>Ordenar Por</label>
            <select
                className='form-select custom-select'
                value={opcaoSelecionada}
                onChange={trocarOpcao}
            >
                <option value="" disabled>Selecione uma opção</option>
                <option value="nmAnuncio">Nome Anúncio</option>
                <option value="vlMinimo">Preço mais baixo</option>
                <option value="vlMaximo">Preço mais alto</option>
            </select>
        </div>
    );    
}

export default OrdenarAnunciosHome;
